import Ajv, { JSONSchemaType, Schema, ErrorObject, ValidateFunction } from 'ajv';
import addFormats from 'ajv-formats';
import addKeywords from 'ajv-keywords';
import addErrors from 'ajv-errors';

import { IInspectionVisitor } from './IInspectionVisitor.model';
import { InspectionPlugin } from './inspectionPlugin.model';
import { IDictionary } from './IDictionary.model';

export class InspectionValidator implements IInspectionVisitor {
  private ajv: Ajv;
  private validators: IDictionary<ValidateFunction> = {};
  public errors: Array<{ data: InspectionPlugin; messages: string[] }> = [];

  constructor(validationSchemas: IDictionary<JSONSchemaType<any>>) {
    this.ajv = new Ajv({ allErrors: true, $data: true });
    addFormats(this.ajv);
    addKeywords(this.ajv);
    addErrors(this.ajv);

    for (let i in validationSchemas) {
      try {
        this.validators[i] = this.ajv.compile(validationSchemas[i]);
      } finally {
      }
    }
  }

  public visit(model: InspectionPlugin): void {
    if (model.pluginType && this.validators[model.pluginType]) {
      let dataToValidate;
      switch (model.pluginType) {
        case 'optimisationmachineselector':
        case 'machineselector':
          dataToValidate = model?.inspection?.data?.machine;
          break;
        case 'customerselector':
          dataToValidate = model?.inspection?.insptectionInspectionCustomer;
          break;
        case 'parts':
          dataToValidate = model?.inspection?.parts;
          break;

        default:
          dataToValidate = model.config;
      }

      if (!dataToValidate) {
        dataToValidate = model.config;
      }

      if (!this.validators[model.pluginType](dataToValidate)) {
        this.errors.push({
          data: model,
          messages: this.validators[model.pluginType].errors.map((x) => x.message)
        });
      }
    }
  }

  public hasErrors(): boolean {
    return this.errors.length > 0;
  }
}
